import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { EVENTS_CONFIG, MILES_TO_KILOMETERS_CONVERSION } from '@app-core/constants/constants';
import { DataService } from '@app-core/services/data/data.service';
import { DateService } from '@app-core/services/date/date.service';
import { NO_DATA_IMAGE } from '@app-driver-management/common/driver-management.constants';
import { DriverDetails } from '@app-driver-management/common/driver-management.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-driver-overview',
  templateUrl: './driver-overview.component.html',
  styleUrls: ['./driver-overview.component.scss'],
})
export class DriverOverviewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public driverDetails: DriverDetails;
  @Input() public loader: boolean = false;

  public currentTheme: string = 'light';
  public eventsConfig;
  public currentDateFormat: string;
  public currentTimeZone: string;
  public currentMetricUnit: string;
  public startDate: string;
  public endDate: string;
  public fleetId: string;
  public areStreaksInsufficient: boolean;
  public hideStreakResponeRate: boolean = true;
  public hideDriverResponseRate: boolean = true;
  public noDataImage: string = NO_DATA_IMAGE;
  public hideDrivingAppreciated: boolean = true;
  public driverAppreciatedClass: string = 'd-hide';
  public initialStreakResponeRateLoader: boolean = true;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(public dataService: DataService, private dateService: DateService, private cdr: ChangeDetectorRef) {
    const combinedEventsList = this.dataService.modifyFleeEvents();
    const modifiedEventsConfig = this.dataService.transformObject(combinedEventsList);
    this.eventsConfig = { ...EVENTS_CONFIG, ...modifiedEventsConfig };
  }

  public ngOnInit(): void {
    const { from: driversStartDate, to: driversEndDate } = this.dateService.getDateRangeInISO(30 * 1); // Past 1 months

    this.startDate = driversStartDate;
    this.endDate = driversEndDate;

    this.dataService._currentDateFormat.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentDateFormat = value;
      }
    });
    this.dataService._currentTimeZone.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentTimeZone = value;
      }
    });
    this.dataService._currentFleet.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.fleetId = value;
      }
    });
    this.dataService._currentTheme.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentTheme = value;
      }
    });
    this.dataService._currentMetricUnit.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentMetricUnit = value;
      }
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.driverDetails && changes.driverDetails.currentValue) {
      this.driverDetails = changes.driverDetails.currentValue;
    }
  }

  public noStreak(event: boolean) {
    this.initialStreakResponeRateLoader = false;
    this.areStreaksInsufficient = event;
  }

  public hideResponseRate(event: boolean) {
    this.initialStreakResponeRateLoader = false;
    this.hideDriverResponseRate = event;
    this.cdr.detectChanges();
  }

  public hideAppreciatedEvents(event: boolean) {
    this.driverAppreciatedClass = event ? 'd-none' : 'd-flex';
    this.hideDrivingAppreciated = event;
  }

  public getStatsValue(data) {
    this.initialStreakResponeRateLoader = false;
    const distanceInMiles = this.currentMetricUnit === 'Miles' ? data.distance / MILES_TO_KILOMETERS_CONVERSION : data.distance;
    if (distanceInMiles < 100) {
      this.hideStreakResponeRate = true;
    } else {
      this.hideStreakResponeRate = false;
    }
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
